<t4-list-view #listVw [options]="listOptions" (onDataRequest)="doPage($event)">
    <ng-container *t4ListItem="let item">
      <th scope="row">{{item.MutationDate | localDateTime }}</th>
      <td>{{item.Amount}}</td>
      <td>{{item.ByFullName}}</td>
    </ng-container>
</t4-list-view>